import { classNames } from '@dimjs/utils';
import { CSSProperties, Fragment, ReactElement, useMemo } from 'react';
import './style.less';

export type SpliceProps = {
  dataList: Array<string | ReactElement | undefined | null>;
  spliceIcon?: ReactElement;
  className?: string;
  style?: CSSProperties;
};
/**
 * 拼接数据，默认使用 | 拼接，可自定义
 * @param props
 * @returns
 */
export const SpliceLayout = (props: SpliceProps) => {
  const renderList = useMemo(() => {
    const tempList = [] as Array<string | ReactElement>;
    const dataList = props.dataList.filter(Boolean) as Array<string | ReactElement>;
    dataList.forEach((item, index) => {
      tempList.push(item);
      if (index < dataList.length - 1) {
        tempList.push(props.spliceIcon ? props.spliceIcon : <span className="v-splice-line" />);
      }
    });
    return tempList;
  }, [props.dataList, props.spliceIcon]);

  return (
    <div className={classNames('v-splice', props.className)} style={props.style}>
      {renderList.map((item, index) => {
        return <Fragment key={index}>{item}</Fragment>;
      })}
    </div>
  );
};
